import React, { forwardRef } from "react";
import cx from 'classnames';
import { NavLink } from "../Nav";
import PathNav from "../Nav/PathNav/PathNav";
import IStyledProps from "../../utilities/IStyledProps";
import IEditableProps from "../../utilities/IEditableProps";
import { BlogResults } from "./BlogResults";
import useQueryParam from '../../utilities/useQueryParam';
import { Column, Content, Row, Search, useLanguage } from '../../../';
import { AutomationPlacement } from '../../utilities/automation';
import { SettingsEnum, getSettingAsObject } from "../../utilities/settings";

export interface IParamNavProps extends IStyledProps, IEditableProps {
    category?: string;
}

const BlogCategoryPage = forwardRef((props: IParamNavProps, ref: any) => {
    const { category = "All" } = props;
    const [tag] = useQueryParam('tag', '');
    const [query] = useQueryParam('q', '');
    const { lang } = useLanguage();
    const allBlogCategories = getSettingAsObject(SettingsEnum.BLOG_CATEGORIES);
    const blogCategoriesLang = allBlogCategories[lang] ? allBlogCategories[lang] : (allBlogCategories['en'] || []);

    return (
        <div ref={ref} data-id={props.cmsId} className={cx(props.editorClassObj)}>
            <Content underhang>
                <Row className="mx-0">
                    <Column className="col-12 mb-lg-5 m-0 p-0">
                        <PathNav rootPath="/must-reads">
                            <NavLink dataTestId="blog-nav-all" name="All" url="" selected={category === 'All'} />
                            {blogCategoriesLang.map(({key, value}) => {
                                return (
                                    <NavLink key={key} dataTestId={`blog-nav-${value}`} name={key} url={value} cmsId={props.cmsId} selected={category === value} />
                                );
                            })}
                        </PathNav>
                    </Column>
                </Row>
                <Row className="mt-0 mx-1 mx-lg-3 row">
                    <Column className="col-12 mb-lg-6 m-0 col-lg">
                        <Search
                            placement={AutomationPlacement.BLOG_CATEGORY_PAGE}
                            inputPlaceholder="Search articles..."
                            containerClass="rounded-lg bg-redRock"
                            inputClass="bg-gray-150"
                            lineColor="transparent"
                            pageType='blog' />
                    </Column>
                </Row>
                <div className="container">
                    <div className="d-flex flex-wrap">
                        <BlogResults limit={9} category={category} tag={tag} query={query} />
                    </div>
                </div>
            </Content>
        </div>
    );
});

export default BlogCategoryPage;